export * from './installation.reducer';
export * from './configuration.reducer';
export * from './startData.reducer';
export * from './extraData.reducer';
export * from './prestacion.reducer';
export * from './prescriptor.reducer';
export * from './efector.reducer';
export * from './diagnostico.reducer';
export * from './atencion.reducer';
export * from './acompanante.reducer';
export * from './derivacion.reducer';
export * from './transacciones.reducer';
